import { IMedia } from '@dtos/Course'
import { useWindowDimensions } from 'react-native'

const VIDEO_PLAYER_HEIGHT = {
  xs: 185,
  sm: 280,
  md: 352,
  lg: 446,
  xl: 446,
  xxl: 446,
}

const TEXT_PLAYER_HEIGHT = {
  xs: 510,
  sm: 636,
  md: 606,
  lg: 606,
  xl: 606,
  xxl: 606,
}

const TEXT_PLAYER_HEIGHT_LOW_HEIGHT = {
  xs: 185,
  sm: 280,
  md: 352,
  lg: 446,
  xl: 446,
  xxl: 446,
}

const IMAGE_PLAYER_HEIGHT = {
  xs: 185,
  sm: 280,
  md: 352,
  lg: 446,
  xl: 446,
  xxl: 446,
}

const EXPANDED_IMAGE_PLAYER_HEIGHT = {
  xs: 600,
  sm: 600,
  md: 650,
  lg: 750,
  xl: 750,
  xxl: 750,
}

const DOCUMENT_PLAYER_HEIGHT = {
  xs: 450,
  sm: 550,
  md: 650,
  lg: 750,
  xl: 850,
  xxl: 950,
}

const AUDIO_PLAYER_HEIGHT = {
  xs: 100,
  sm: 120,
  md: 140,
  lg: 160,
  xl: 180,
  xxl: 200,
}

interface IMediaRenderWrapperDynamicHeightProps {
  mediaSize: string
  mediaType: IMedia['type']
  isExpanded: boolean
  textHeight: number
}

export function useMediaRenderWrapperDynamicHeight({
  mediaSize,
  mediaType,
  isExpanded,
  textHeight,
}: IMediaRenderWrapperDynamicHeightProps) {
  const { height: windowHeight } = useWindowDimensions()

  const getDynamicHeight = (baseHeight: number) => {
    if (['xs', 'sm'].includes(mediaSize)) {
      return windowHeight - 120
    }
    return baseHeight
  }

  const getTextHeight = () => {
    if (textHeight < 185) {
      return TEXT_PLAYER_HEIGHT_LOW_HEIGHT[
        mediaSize as keyof typeof TEXT_PLAYER_HEIGHT_LOW_HEIGHT
      ]
    }

    if (textHeight >= 185 && textHeight < 510) {
      return textHeight
    }

    return TEXT_PLAYER_HEIGHT[mediaSize as keyof typeof TEXT_PLAYER_HEIGHT]
  }

  switch (mediaType) {
    case 'Video':
      return VIDEO_PLAYER_HEIGHT[mediaSize as keyof typeof VIDEO_PLAYER_HEIGHT]
    case 'Image':
      return isExpanded
        ? getDynamicHeight(
            EXPANDED_IMAGE_PLAYER_HEIGHT[
              mediaSize as keyof typeof EXPANDED_IMAGE_PLAYER_HEIGHT
            ],
          )
        : IMAGE_PLAYER_HEIGHT[mediaSize as keyof typeof IMAGE_PLAYER_HEIGHT]
    case 'Text':
      return getTextHeight()
    case 'Document':
      return DOCUMENT_PLAYER_HEIGHT[
        mediaSize as keyof typeof DOCUMENT_PLAYER_HEIGHT
      ]
    case 'Audio':
      return AUDIO_PLAYER_HEIGHT[mediaSize as keyof typeof AUDIO_PLAYER_HEIGHT]
    default:
      return VIDEO_PLAYER_HEIGHT[mediaSize as keyof typeof VIDEO_PLAYER_HEIGHT]
  }
}
